import { createEvent, createStore } from 'effector';
import { AlertProps } from '@mui/material';
import { signout } from '@features/common';

export type ToastData = {
  visible: boolean;
  text: string;
  type?: AlertProps['severity'];
  autoHideTimerMs?: number;
};

export const setToastData = createEvent<ToastData | null>();
export const hideToast = createEvent();

export const $toastData = createStore<ToastData | null>(null)
  .on(setToastData, (_, data) => data)
  .on(hideToast, (state) => ({ ...state, visible: false } as ToastData))
  .reset(signout);
